import React, { useState } from "react";
import "./SearchBox.css";
import SearchIcon from "@mui/icons-material/Search";
import { useCommentData } from "./CommentDataContext";
import Toast from "./Toast";

const SearchBox = () => {
  const [searchComment, setSearchComment] = useState("");
  const { setSearchedCommentQueries, setSearchActive } = useCommentData();
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMsg, setToastMsg] = useState("");

  const handleCommentSearch = () => {
    const term = (searchComment || "").trim();

    if (term === "") {
      setSearchActive(false);
      setSearchedCommentQueries(null);
      return;
    }

    const result = window?.canvasEngine?.FeatureRenderer?.searchComments?.(term);
    setSearchedCommentQueries(result);
    setSearchActive(true);
    setSearchComment('')
    if (result.length === 0) {
      setToastMsg("No matching comments found.");
      setToastOpen(true);
      setSearchComment("");
      setSearchedCommentQueries(null);
      setSearchActive(false);
    }
  };

  return (
    <div className="searchbox-container">
      <input
        id="searchComment"
        name="searchComment"
        type="text"
        value={searchComment}
        onChange={(e) => {
          const v = e.target.value;
          setSearchComment(v);
          if (v.trim() === "") {
            setSearchActive(false);
            setSearchedCommentQueries(null);
          }
        }}
        placeholder="Search your comment"
        className="searchbox-input"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleCommentSearch();
          } else if (e.key === "Escape") {
            setSearchActive(false);
            setSearchedCommentQueries(null);
            setSearchComment("");
          } else { return; }
        }}
      />
      <button
        title="Search Comment"
        className="icon-search"
        onClick={handleCommentSearch}
      >
        <SearchIcon />
      </button>

      {/* Toast */}
      <Toast
        open={toastOpen}
        onClose={() => setToastOpen(false)}
        message={toastMsg}
        severity="error"
      />
    </div>
  );
};

export default SearchBox;